export default function (el, binding, vnode) {
  debugger;
  el.addEventListener('keyup', (ev) => {
    const index = [...vnode.elm.elements].indexOf(ev.target);

    if (ev.keyCode === 13 && index < vnode.elm.length - 1) {
      vnode.elm[index + 1].focus();
    }
  });
}
